import React from "react";
import UserLayout from "../../components/Layout/UserLayout";
import { nonfictionfold1 } from "../../asserts/images";
import InnerHero from "../../components/InnerHero";
import Section2 from "../../components/Section2";
import CustomCategory from "../../components/CustomCategory";
import SecondCustomBanner from "../../components/SecondCustomBanner";
import FirstCustomBanner from "../../components/FirstCustomBanner";
import PublishBook from "../../components/PublishBook";
import Testimonial from "../../components/Testimonial";
import CustomPublication from "../../components/CustomPublication";
import Faq from "../../components/Faq";
import GetTouch from "../../components/GetTouch";
import { Helmet } from "react-helmet";

const GhostWriter = () => {
  return (
    <>

      <Helmet>
        <meta charSet="utf-8" />
        <title>
            Top Non-Fiction Writing Services | Falcon Book Writing
        </title>
        <meta
          name="description"
          content="Falcon Book Writing offers expert Non-Fiction Writing Services, helping authors create polished, engaging books that inform, inspire, and elevate their brand."
        />
        <meta name="keywords" content="Non-Fiction Writing Services" />
        <link rel="canonical" href={window.location.href} />
      </Helmet>

      <UserLayout>
        <InnerHero
          innerheroclass="ghostwritingBg nonfictionbg"
          title="Make Every Fact and Insight Come Alive in"
          subtitle=" Non-Fiction Writing "
          title2=""
          para="Every insight, every fact, has a story waiting to be told. Our non-fiction writing brings your knowledge and experiences to life, transforming research, ideas, and real events into engaging, memorable, and impactful narratives for readers."
        />

        <Section2
          innerSec2Class="innerbrilliant_mind_section innerpages-sec-2"
          title={` `}
          subtitle="  Non-Fiction Writing "
          title2="That Leaves a Meaningful Impact"
          description={`Every piece of non-fiction writing has the power to inform, inspire, and influence. By capturing real events, research, and experiences with clarity and depth, non-fiction writing can leave a lasting impression on readers. We transform facts and insights into compelling narratives that educate, engage, and resonate on a personal level. Whether it’s a biography, self-help guide, educational book, or business insight, each manuscript is carefully crafted to highlight the essence of the subject while maintaining authenticity and credibility. Our writing turns knowledge into stories that readers remember, learn from, and share. Every word is chosen with intention, ensuring your message not only reaches readers but stays with them. Make your ideas meaningful, memorable, and impactful through expertly written non-fiction. `}
          // subtitle1="How we work?"
          // subtitle1Desc="At Random House Publishers, we pride ourselves on being the conduit through which your imagination flows into the world. Our ghostwriting service is designed to empower authors like you to bring your stories to life, even if you need a little extra support along the way. Here’s how we work for you:"
          // subtitle2="    Tailored Collaborations?"
          // subtitle2Desc="We understand that every author is unique, and so are their needs. That’s why we offer personalized ghostwriting services tailored to your specific vision and requirements. Whether you have a fully fleshed-out plot or just a spark of an idea, our team of experienced ghostwriters will work closely with you to bring your story to fruition."
          // subtitle3="  Expert Guidance"
          // subtitle3Desc="Writing a book can be a daunting task, but you don’t have to go it alone. When you choose Random House Publishers, you gain access to a team of seasoned professionals who are passionate about storytelling. From brainstorming sessions to plot development and character arcs, we’ll be there to guide you every step of the way."
          // subtitle3Desc2="Writing a book can be a daunting task, but you don’t have to go it alone. When you choose Random House Publishers, you gain access to a team of seasoned professionals who are passionate about storytelling. "
          image={nonfictionfold1}
          imgClass="ghost-img2"
        />

        <CustomCategory className="category_section2" />
        <FirstCustomBanner />
        <PublishBook />
        <Testimonial />
        <SecondCustomBanner />
        <CustomPublication />
        <Faq />
        <GetTouch />
      </UserLayout>
    </>
  );
};

export default GhostWriter;
